export default __webpack_public_path__ + "media/music/70f9db86c4d52891005ad6c7709b7537.mp3";